export function isRemIfengPage() {
    return window.allData &&  window.__IFENG_ENV__ && window.__IFENG_ENV__.minWidth>0&&window.__IFENG_ENV__.maxWidth>0 && window.__IFENG_ENV__.divisor >0
}
export function getRemPageFont() {
    if (document.documentElement.style.fontSize){
        return document.documentElement.style.fontSize.replace("px","");
    }
    return 0
}
export function getWH(len, size){
    return len * size / window.IfengAmgr.maxfontsize; 
}

export function getMaxfontsize(){
    if(isRemIfengPage()){
        return window.__IFENG_ENV__.maxWidth / window.__IFENG_ENV__.divisor;
    }
    return 14;
}

export function getRemfontsize(val){
    let size = getMaxfontsize();
    return val / size ;
}